import { type DragHandlerStore } from './factory';

import { context } from './context';

export const TableHandlerStateProvider = ({
  children,
  store,
}: {
  children: React.ReactNode;
  store: DragHandlerStore;
}) => {
  return <context.Provider value={store}>{children}</context.Provider>;
};
